var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBidOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0892506 2.29508C0.0892506 1.02755 1.11679 0 2.38433 0H11.5647C12.8322 0 13.8597 1.02754 13.8597 2.29508V7.10382C13.8597 8.37136 12.8322 9.39891 11.5647 9.39891H7.73952V12.4444H6.20947V9.39891H2.38433C1.11679 9.39891 0.0892506 8.37136 0.0892506 7.10383V2.29508ZM2.38433 1.53005C1.96182 1.53005 1.61931 1.87257 1.61931 2.29508V7.10383C1.61931 7.52634 1.96182 7.86885 2.38433 7.86885H11.5647C11.9872 7.86885 12.3297 7.52634 12.3297 7.10382V2.29508C12.3297 1.87257 11.9872 1.53005 11.5647 1.53005H2.38433ZM6.46448 6.94712L9.55553 3.85608L8.47361 2.77416L6.46448 4.7833L5.47538 3.7942L4.39347 4.87611L6.46448 6.94712Z",
    fill: "var(--secondary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidOutlined);
export default __webpack_public_path__ + "static/media/bidOutlined.bd3bbb35d27dbdcbac729a67438ab69c.svg";
export { ForwardRef as ReactComponent };